import { usePaymentContext } from "@/context-state/PaymentContext"
import { handleError } from "@/services/errorHandler"
import { getEntitlementsOfAccount } from '@/services/api.js'

export const useSyncEntitlements = () => {

    const { updateEntitlements } = usePaymentContext()

    return async () => {
        try {
            const entitlementsResponse = await getEntitlementsOfAccount()
            updateEntitlements(entitlementsResponse.data)
        } catch (e) {
            console.error(e)
            handleError(e)
        }

    }
}